export const validationPatterns = {
  noteValidation: /^\w-|.|\(|\)|,|\/|_|;|:|@\s+$/,
  nameValidation: /^\w|-|_\s+$/,
  alphaNumeric: /^\w+$/,
  digits: /^\d+$/,
  usernameOrEmail: /^\w-|.|@|_\s+$/,
  // eslint-disable-next-line no-useless-escape
  email: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  day: /^\d{4}-\d{2}-\d{2}$/,
  drsDeposit: /^(DRS Deposit|DRS Fee|Deposit Return Scheme)/i,
  categoryCode: /^\d+(\.\d+){0,2}$/,
  url: /^(https?:\/\/)?(www\.)?(?:localhost|(?:\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})|[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b)([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/
};
